// noinspection JSVoidFunctionReturnValueUsed

const productRangeCreate = ((jQuery) => {
  'use strict';

  let $form = jQuery('#create_personalized_form');

  if ($form.length === 0) {
    return;
  }

  $("#display-search-product").on('click', function (e) {
    $("#select-products").show();
    $("#hide-search-product").show();
    $("#display-search-product").hide();
  });

  $("#hide-search-product").on('click', function (e) {
    $("#select-products").hide();
    $("#hide-search-product").hide();
    $("#display-search-product").show();
  });

  const changeProduct = () => {
    $("#select-products").hide();
    $("#hide-search-product").hide();
    $("#display-search-product").show();

    let sentence = '0 sélectionné(s)';
    $('#selectedProducts').val(sentence);

    $.ajaxSetup({
      headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
      }
    });
    $.ajax({
      url: '/insights/personalized-report/searchProduct',
      data:  JSON.stringify({
        distributor: $('#distributor').val(),
        sector: $('#sector').val(),
        subsector: $('#subsector').val(),
        family: $('#family').val(),
        brand: $('#brand').val()
      }),
      contentType: 'application/json',
      type: 'POST',
      success: function (response) {
        Livewire.emit('UpdateSelectedProducts', []);
        $('#products').empty();
        $.each(response, function (index, product) {
          $('#products').append('<option value="' + product.id + '">' + product.name + '</option>');
        });
        $('#products').bootstrapDualListbox('refresh');
      }
    });
  };

  const changeBrand = () => {
    $form.find("#brand").on('change', function (e) {
      changeProduct();
    });
  };
  const changeDistributor = () => {
    $form.find("#distributor").on('change', function (e) {
      changeProduct();
    });
  };

  const changeSector = () => {
    $form.find("#sector").on('change', function (e) {
      changeProduct();
    });
  };

  const changeSubSector = () => {
    $form.find("#subsector").on('change', function (e) {
      changeProduct();
    });
  };

  const changeFamily = () => {
    $form.find("#family").on('change', function (e) {
      changeProduct();
    });
  };


  document.addEventListener('livewire:load', function () {
    $('select[name="products[]"]').bootstrapDualListbox({
      nonSelectedListLabel: 'Produits disponibles',
      selectedListLabel: 'Produits sélectionnés',
      preserveSelectionOnMove: 'moved',
      moveAllLabel: 'Tout sélectionner',
      removeAllLabel: 'Tout retirer'
    }).on('change', function () {
      let selectedProducts = $(this).val();
      let sentence = selectedProducts.length + ' sélectionné(s)';
      $('#selectedProducts').val(sentence);
    });

    var dualListContainer = $('select[name="products[]"]').bootstrapDualListbox('getContainer');
    dualListContainer.find('.moveall i').removeClass().addClass('fa fa-arrow-right');
    dualListContainer.find('.removeall i').removeClass().addClass('fa fa-arrow-left');
    dualListContainer.find('.move i').removeClass().addClass('fa fa-arrow-right');
    dualListContainer.find('.remove i').removeClass().addClass('fa fa-arrow-left');
  });

  document.addEventListener('livewire:load', function () {
    $form.find("#submitform").on('click', function (e) {
      Livewire.emit('SubmitForm', $('select[name="products[]"]').val(), 'create');
    });
  });

  jQuery(() => {
    changeBrand();
    changeFamily();
    changeSubSector();
    changeSector();
    changeDistributor();
  });

})(jQuery);
